// removed by extract-text-webpack-plugin
module.exports = {"danang-business":"danang-business","advanced-search":"advanced-search","wrap-advanced-search":"wrap-advanced-search","search-box":"search-box","business-list":"business-list","business-item":"business-item","name":"name","business-info":"business-info","business-contact":"business-contact","business-action":"business-action","send-request":"send-request","detail":"detail","pagination":"pagination"};


//////////////////
// WEBPACK FOOTER
// ./components/business/danang-business/style.scss
// module id = ./components/business/danang-business/style.scss
// module chunks = 0